<template>
  <section id="login" class="mt-5">
    <div class="container-fluid">
      <div class="row full-height-vh">
        <div class="col-12 d-flex align-items-center justify-content-center gradient-aqua-marine">
          <div class="card px-4 py-2 box-shadow-2 width-600">
            <div class="card-header text-center">
              <h1>{{ $t("labels.resendActivation") }}</h1>
            </div>
            <div class="card-body">
              <div class="card-block">
                <form @submit.prevent="resendActivation">
                  <div class="form-group">
                    <div class="col-md-12">
                      <input type="email" class="form-control form-control-lg" name="inputEmail" id="inputEmail"
                        v-model="email" :placeholder='$t("labels.email")' required email>
                    </div>
                  </div>

                  <div class="form-group">
                    <div class="text-center col-md-12">
                      <button type="submit"
                        class="btn btn-danger px-4 py-2 text-uppercase white font-small-4 box-shadow-2 border-0">{{ $t("labels.submit") }}</button>
                    </div>
                  </div>
                </form>
                 <ul class="links">
                    <li>
                      <router-link :to="{ name: 'login', query: {l: currentLocale }}">{{ $t("labels.haveAnAccount") }}</router-link>
                    </li>
                    <li>
                      <router-link :to="{ name: 'register', query: {l: currentLocale }}">{{ $t("labels.register") }}</router-link>
                    </li>
                    <li>
                      <router-link :to="{ name: 'forgot', query: {l: currentLocale }}">{{ $t("labels.forgotPassword") }}</router-link>
                    </li>
                  </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import AuthService from "../../services/auth";

  export default {
    name: "LoginPage",
    metaInfo: {
      title: "Dravet Diary Admin", // set a title
      titleTemplate: "%s" // title is now "My Example App - Yay!",
    },
    props: {
      currentLocale: {
        type: String,
        default: 'it'
      }
    },
    data: function () {
      return {
        errors: [],
        email: ''
      };
    },
    methods: {
      resendActivation: async function () {
        if (this.email == undefined || this.email.length == 0) {
          this.errors.push(this.$t("errors.cantBeEmpty", ["E-mail"]))
        }
        if (!this.emailValidator(this.email)) {
          this.errors.push(this.$t("errors.invalidEmail"))
        }
        if (this.errors.length == 0) {
          let result = await AuthService.resendActivation(this.email)
          this.email = ''
          this.$miniToastr.success(this.$t("flash.activationEmailSuccess"))
          this.$router.push({
            name: "login"
          })
        } else {
          this.$miniToastr.error(this.$t("errors.invalidEmail"))
        }
      },
      emailValidator(email) {
        let re =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email)
      }
    }
  };
</script>